// extracted by mini-css-extract-plugin
export default {"flexContainer":"Step2_flexContainer__+BOso","uploadContainer":"Step2_uploadContainer__rzBaW","listContainer":"Step2_listContainer__zfTOZ"};